import { render } from "./ItemConfigurationsView.vue?vue&type=template&id=072697a8"
import script from "./ItemConfigurationsView.vue?vue&type=script&lang=js"
export * from "./ItemConfigurationsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__